import { Form, Modal } from "antd";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../app/hooks";
import { selectCurrentBusiness } from "../../../businesses/businessesSlice";

// import {
//   getAccountingReportFromServer,
//   getPayoutReportFromServer,
//   getSalesOverviewReportFromServer,
//   getTransactionsOverviewReportFromServer,
// } from "../../reportsApi";
import {
  IPartnerReportRequest,
  IReportRequest,
} from "../../../../interfaces/requestReport.interface";

import dayjs from "dayjs";
import {
  IPartnerReport,
  IReportResponse,
} from "../../../../interfaces/reports.interface";
import CreateReportForm from "../../../common/create-report-form/CreateReportForm";
import { selectCurrentPartner } from "../../partnersSlice";
import { getPartnerMarkupReportFromServer } from "../../partnersApi";
import { Language } from "../../../../interfaces/language.enum";

interface IPropsCreateReportFormModal {
  visible: boolean;
  setVisible: any;
}

let ReportOptions: IPartnerReport[] = [
  {
    type: "resellerMarkupReport",
    label: "Reseller Markup Report",
    formatTypes: ["XLSX"],
    previewUrl: "/assets/icons/report/sales-overview.svg",
    description:
      "Get the reseller partner mark up for the selected time period.",
  },
  {
    type: "softwareVendorMarkupReport",
    label: "ISV Markup Report",
    formatTypes: ["XLSX"],
    previewUrl: "/assets/icons/report/transactions-overview.svg",
    description:
      "Get the software vendor partner mark up for the selected time period.",
  },
];

export default function CreatePartnerReportFormModal({
  visible,
  setVisible,
}: IPropsCreateReportFormModal) {
  const currentPartner = useAppSelector(selectCurrentPartner);
  const [report, setReport] = useState<IPartnerReport>(ReportOptions[0]);
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      dateRange: [
        dayjs().subtract(1, "day").hour(0).minute(0).second(0),
        dayjs().hour(23).minute(59).second(59),
      ],
    });
  }, [report.type]);

  const handleSubmit = async (
    reportRequest: IReportRequest,
    reportType?: string
  ) => {
    let partnerReportRequest = {
      ...reportRequest,
      partnerId: currentPartner._id,
      reportType:
        reportType === "resellerMarkupReport" ? "reseller" : "softwareVendor",
    } as IPartnerReportRequest;

    let results = {} as IReportResponse;
    // if (reportType === "resellerMarkupReport") {
    await getPartnerMarkupReportFromServer(partnerReportRequest)
      .then((d) => (results = d))
      .catch((e) => alert(`Error: ${e}`));

    return results;
    // }else{

    // }
  };
  const handleCancel = () => {
    // handleReset();
    setVisible(false);
  };

  return (
    <Modal
      visible={visible}
      title={"Create Report For " + currentPartner?.name}
      onCancel={handleCancel}
      footer={null}
      width={650}
    >
      <CreateReportForm
        onSubmit={handleSubmit}
        reportOptions={ReportOptions}
        languageOptions={[
          { label: "Italian", value: Language.Italian },
          { label: "Dutch", value: Language.Dutch },
          { label: "German", value: Language.German },
          { label: "English", value: Language.English },
          { label: "French", value: Language.French },
        ]}
      ></CreateReportForm>
    </Modal>
  );
}
